import { z } from "zod";
import { contactCrmWriteFieldsSchema } from "./contact-contracts.js";
import { contactGroupSelectionFieldsSchema } from "./contact-group-selection.js";
import { apiIntIdSchema } from "./ids.js";
/** Derived contact state for a ContactPlatformProfile. Not stored in PostgreSQL. */
export const CONTACT_STATES = ["NOT_SAVED", "ACTIVE", "DELETED"];
export const contactStateSchema = z.enum(CONTACT_STATES);
export const linkedContactDtoSchema = z.object({
    id: apiIntIdSchema,
    displayName: z.string(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
});
export const contactPlatformProfileSummaryDtoSchema = z.object({
    id: apiIntIdSchema,
    platformDisplayName: z.string().nullable(),
    platformUsername: z.string().nullable(),
    normalizedPhoneNumber: z.string().nullable(),
    platformProfileImageUrl: z.string().nullable(),
    contactState: contactStateSchema,
    contact: linkedContactDtoSchema.nullable(),
});
export const ADD_CONTACT_MODES = ["CREATE_NEW", "RESTORE_EXISTING", "LINK_EXISTING"];
export const addPlatformProfileAsContactRequestSchema = z.discriminatedUnion("mode", [
    contactCrmWriteFieldsSchema.extend({
        mode: z.literal("CREATE_NEW"),
        ...contactGroupSelectionFieldsSchema,
    }),
    z.object({
        mode: z.literal("RESTORE_EXISTING"),
    }),
    z.object({
        mode: z.literal("LINK_EXISTING"),
        contactId: apiIntIdSchema,
        /** Required when Contact phone differs from WhatsApp provider phone. */
        confirmWhatsAppPhoneReplacement: z.boolean().optional(),
    }),
]);
export const addPlatformProfileAsContactResponseSchema = z.object({
    contactId: apiIntIdSchema,
    contactState: z.literal("ACTIVE"),
    profileId: apiIntIdSchema,
    contactPlatformProfile: contactPlatformProfileSummaryDtoSchema,
});
//# sourceMappingURL=contact-state.js.map